export default __webpack_public_path__ + "static/favicon-a2891b8545d97fc60bd018cd1c4dcadc.ico";